// iCraftz — i18n Translations Bundle
// All UI strings in 10 languages.
// Book content (summary, insights, actionItems, coreTheme) is NOT here
// — it is translated live via Anthropic API on demand.

const translations = {

  en: {
    langLabel: "English",
    nav: { home: "Home", library: "Library", categories: "Categories", waitlist: "Join Waitlist" },
    landingNav: {
      library: "Library",
      collections: "Collections",
      sanctuary: "My Sanctuary",
      journey: "My Journey",
      pricing: "Pricing",
      beginJourney: "Begin Journey",
    },
    libraryBanner: {
      title: "Every transformation begins with one idea.",
      sub: "Select a book. Discover an idea. Install a practice.",
    },
    transformationJourney: {
      heading: "The Transformation Journey",
      subtitle: "Five steps from reading to transformation.",
      steps: [
        { key: "jigyasa",  title: "Jigyasa",  sub: "Discover a book that inspires you" },
        { key: "bodha",    title: "Bodha",    sub: "Understand its key ideas" },
        { key: "sankalpa", title: "Sankalpa", sub: "Choose one idea to install" },
        { key: "sadhana",  title: "Sadhana",  sub: "Follow your 30-day practice" },
        { key: "siddhi",   title: "Siddhi",   sub: "Build identity. Transform." },
      ],
    },
    mycraftzInstall: {
      buttonLabel: "MyCraftz™",
      steps: { recall: "Recall", choose: "Choose", commit: "Commit", plan: "Plan", action: "Action", reflect: "Reflect" },
      recall: {
        heading: "What This Book Taught You",
        summaryLabel: "The Summary",
        insightsLabel: "Key Insights",
        coreThemeLabel: "Core Theme",
        cta: "Choose What To Install →",
      },
      choose: {
        heading: "Pick One Idea To Install",
        loading: "Discovering the ten ideas worth installing…",
        retry: "Try again",
        cta: "Commit To This →",
      },
      commit: {
        heading: "You Have Chosen",
        whyLoading: "Reflecting on why this matters…",
        checkboxLabel: "I commit to practising this for 30 days.",
        cta: "Build My Plan →",
      },
      plan: {
        heading: "Your 30-Day Blueprint",
        loading: "Designing your daily practice…",
        triggerLabel: "Trigger",
        actionLabel: "Daily Action",
        durationLabel: "Duration",
        reminderLabel: "Reminder",
        quoteLoading: "Finding a verse for this idea…",
        cta: "Start My 30 Days →",
      },
      action: {
        heading: "Today's Practice",
        dayLine: "Day 1 of 30",
        durationSuffix: ". That is enough.",
        doneCta: "I've Done It ✓",
        doneToast: "Well done. Come back tomorrow.",
        sub: "Come back tomorrow for Day 2.",
        continueCta: "Continue in MyCraftz™ →",
      },
      reflect: {
        heading: "Capture Today's Learning",
        f1Label: "What did I notice today?",
        f1Placeholder: "Share what came up...",
        f2Label: "What was difficult?",
        f2Placeholder: "Be honest...",
        f3Label: "What will I do tomorrow?",
        f3Placeholder: "Your intention...",
        saveCta: "Save Reflection",
        savedTitle: "Your reflection has been saved.",
        backToLibrary: "Back to Library",
        share: "Share My Commitment",
        shareText: "I just installed an idea from {book} into my life with iCraftz™.",
      },
      errors: {
        generic: "Something didn't load. Please try again.",
      },
    },
    hero: {
      badge: "FOR THE GENERATION THAT WANTS MORE",
      tagline: "STOP SCROLLING. START GROWING.",
      subheading: "From Reading to Identity.",
      subtext: "The algorithm keeps you scrolling. iCraftz flips that — putting the world's best non-fiction books to work so you actually change, not just consume.",
      cta: "Begin Your Journey",
      secondaryCta: "Explore Reading Paths",
      subCta: "Be among the first to experience iCraftz",
    },
    howItWorks: {
      heading: "How It Works",
      steps: [
        { title: "Pick a Book", desc: "Browse our curated library of 49 life-changing non-fiction books." },
        { title: "Discover Insights", desc: "Explore the key ideas, themes and lessons in your language." },
        { title: "Apply to Your Life", desc: "Get practical action items you can start using today." },
      ],
    },
    library: { heading: "Your Personal Library", subheading: "8 transformative books with AI-powered action plans", searchPlaceholder: "Search books..." },
    categories: {
      heading: "Transform Your Life",
      subheading: "Explore books by the area of life you want to improve.",
      bookCount: "books",
      comingSoon: "Coming Soon — Curating the best books for this area!",
      names: {
        "Mind & Mindset": "Mind & Mindset",
        "Wealth & Money": "Wealth & Money",
        "Health & Body": "Health & Body",
        "Purpose & Spirituality": "Purpose & Spirituality",
        "Habits & Productivity": "Habits & Productivity",
        "Focus & Deep Work": "Focus & Deep Work",
        "Leadership & Influence": "Leadership & Influence",
        "Career & Business": "Career & Business",
        "Relationships & Communication": "Relationships & Communication",
        "Creativity & Expression": "Creativity & Expression",
        "Nutrition & Wellness": "Nutrition & Wellness",
        "Grief, Loss & Healing": "Grief, Loss & Healing",
        "Success": "Success",
        "Motivation": "Motivation",
        "Spirituality": "Spirituality",
        "Mental Wellness": "Mental Wellness",
        "Health": "Health",
        "Finance": "Finance",
        "Productivity": "Productivity",
        "Creativity": "Creativity",
        "Communication": "Communication",
      },
    },
    modal: {
      labels: { summary: "Summary", insights: "Key Insights", actionItems: "Action Items", coreTheme: "Core Theme" },
      translating: "Translating...",
      translationUnavailable: "Translation unavailable. Showing English.",
    },
    waitlist: {
      heading: "Be First to Experience iCraftz",
      subheading: "Join thousands of readers turning wisdom into action.",
      placeholder: "Enter your email address",
      cta: "Join the Waitlist",
      success: "You're on the list! We'll be in touch soon.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "Turn Pages Into Practice",
      links: { about: "About", faq: "FAQ", contact: "Contact", product: "Product", library: "Book Library", features: "Features", howItWorks: "How it Works", company: "Company", resources: "Resources", blog: "Blog", helpCenter: "Help Center", community: "Community", privacy: "Privacy Policy", terms: "Terms of Service" },
      copyright: "© 2025 iCraftz. All rights reserved.",
    },
  },

  hi: {
    langLabel: "हिंदी",
    nav: { home: "होम", library: "लाइब्रेरी", categories: "श्रेणियाँ", waitlist: "वेटलिस्ट में जुड़ें" },
    hero: {
      tagline: "सिर्फ पढ़ो मत। स्वयं को रूपांतरित करो।",
      subtext: "iCraftz पढ़ने से कहीं आगे की यात्रा है। यह दुनिया की सबसे गहन नॉन-फिक्शन किताबों की अनमोल बुद्धिमत्ता को आपके जीवन में उतार देता है — ऐसे ठोस कर्म और निर्णय जो आपको भीतर से बदल दें।",
      cta: "वेटलिस्ट में जुड़ें",
      subCta: "iCraftz अनुभव करने वालों में पहले बनें",
    },
    howItWorks: {
      heading: "यह कैसे काम करता है",
      steps: [
        { title: "एक किताब चुनें", desc: "49 जीवन-परिवर्तन करने वाली नॉन-फिक्शन किताबों की हमारी लाइब्रेरी ब्राउज़ करें।" },
        { title: "अंतर्दृष्टि खोजें", desc: "अपनी भाषा में मुख्य विचार, विषय और सबक जानें।" },
        { title: "अपने जीवन में लागू करें", desc: "व्यावहारिक कार्य आइटम पाएं जिन्हें आप आज से शुरू कर सकते हैं।" },
      ],
    },
    library: { heading: "आपकी व्यक्तिगत लाइब्रेरी", subheading: "AI-संचालित एक्शन प्लान के साथ 8 परिवर्तनकारी किताबें", searchPlaceholder: "किताबें खोजें..." },
    categories: {
      heading: "अपना जीवन बदलें",
      subheading: "उस जीवन क्षेत्र के अनुसार किताबें खोजें जिसे आप सुधारना चाहते हैं।",
      bookCount: "किताबें",
      comingSoon: "जल्द आ रहा है — इस क्षेत्र के लिए सर्वोत्तम किताबें क्यूरेट कर रहे हैं!",
      names: {
        "Mind & Mindset": "मन और मानसिकता",
        "Wealth & Money": "धन और पैसा",
        "Health & Body": "स्वास्थ्य और शरीर",
        "Purpose & Spirituality": "उद्देश्य और आध्यात्मिकता",
        "Habits & Productivity": "आदतें और उत्पादकता",
        "Focus & Deep Work": "फोकस और गहरा काम",
        "Leadership & Influence": "नेतृत्व और प्रभाव",
        "Career & Business": "करियर और व्यवसाय",
        "Relationships & Communication": "रिश्ते और संवाद",
        "Creativity & Expression": "रचनात्मकता और अभिव्यक्ति",
        "Nutrition & Wellness": "पोषण और तंदुरुस्ती",
        "Grief, Loss & Healing": "दुःख, हानि और उपचार",
        "Success": "सफलता",
        "Motivation": "प्रेरणा",
        "Spirituality": "आध्यात्मिकता",
        "Mental Wellness": "मानसिक स्वास्थ्य",
        "Health": "स्वास्थ्य",
        "Finance": "वित्त",
        "Productivity": "उत्पादकता",
        "Creativity": "रचनात्मकता",
        "Communication": "संवाद",
      },
    },
    modal: {
      labels: { summary: "सारांश", insights: "मुख्य अंतर्दृष्टि", actionItems: "कार्य बिंदु", coreTheme: "मूल विषय" },
      translating: "अनुवाद हो रहा है...",
      translationUnavailable: "अनुवाद उपलब्ध नहीं। अंग्रेज़ी दिखाई जा रही है।",
    },
    waitlist: {
      heading: "iCraftz का पहला अनुभव लें",
      subheading: "हजारों पाठकों से जुड़ें जो ज्ञान को कार्य में बदल रहे हैं।",
      placeholder: "अपना ईमेल पता दर्ज करें",
      cta: "वेटलिस्ट में जुड़ें",
      success: "आप सूची में हैं! हम जल्द संपर्क करेंगे।",
      error: "कुछ गलत हुआ। कृपया पुनः प्रयास करें।",
    },
    footer: {
      tagline: "पन्नों को अभ्यास में बदलें",
      links: { about: "हमारे बारे में", faq: "सामान्य प्रश्न", contact: "संपर्क करें", product: "उत्पाद", library: "पुस्तक पुस्तकालय", features: "विशेषताएं", howItWorks: "कैसे काम करता है", company: "कंपनी", resources: "संसाधन", blog: "ब्लॉग", helpCenter: "सहायता केंद्र", community: "समुदाय", privacy: "गोपनीयता नीति", terms: "सेवा की शर्तें" },
      copyright: "© 2025 iCraftz. सर्वाधिकार सुरक्षित।",
    },
  },

  te: {
    langLabel: "తెలుగు",
    nav: { home: "హోమ్", library: "లైబ్రరీ", categories: "వర్గాలు", waitlist: "వెయిట్‌లిస్ట్‌లో చేరండి" },
    hero: {
      tagline: "చదవడం మాత్రమే కాదు. మీ జీవితాన్ని మార్చుకోండి.",
      subtext: "iCraftz ఒక సాధారణ పఠన యాత్ర కాదు. ప్రపంచంలోని అత్యుత్తమ నాన్-ఫిక్షన్ గ్రంథాల గాఢమైన జ్ఞానాన్ని, మీ జీవితాన్ని లోతుగా మలచగల ఆచరణగా మార్చే ఒక పరివర్తనా మార్గం.",
      cta: "వెయిట్‌లిస్ట్‌లో చేరండి",
      subCta: "iCraftz అనుభవించే మొదటివారిలో ఒకరు అవ్వండి",
    },
    howItWorks: {
      heading: "ఇది ఎలా పని చేస్తుంది",
      steps: [
        { title: "పుస్తకం ఎంచుకోండి", desc: "49 జీవితాన్ని మార్చే నాన్-ఫిక్షన్ పుస్తకాల మా సేకరణను చూడండి." },
        { title: "అంతర్దృష్టులు కనుగొనండి", desc: "మీ భాషలో ముఖ్యమైన ఆలోచనలు, థీమ్‌లు మరియు పాఠాలను అన్వేషించండి." },
        { title: "మీ జీవితంలో అన్వయించండి", desc: "మీరు నేడే ప్రారంభించగల ఆచరణాత్మక కార్యాచరణ అంశాలు పొందండి." },
      ],
    },
    library: { heading: "మీ వ్యక్తిగత లైబ్రరీ", subheading: "AI-ఆధారిత యాక్షన్ ప్లాన్‌లతో 8 పరివర్తనాత్మక పుస్తకాలు", searchPlaceholder: "పుస్తకాలు వెతకండి..." },
    categories: {
      heading: "మీ జీవితాన్ని మార్చండి",
      subheading: "మీరు మెరుగుపరచాలనుకునే జీవిత రంగం ద్వారా పుస్తకాలను అన్వేషించండి.",
      bookCount: "పుస్తకాలు",
      comingSoon: "త్వరలో వస్తుంది — ఈ రంగానికి అత్యుత్తమ పుస్తకాలను సేకరిస్తున్నాం!",
      names: {
        "Mind & Mindset": "మనసు & మానసిక స్థితి",
        "Wealth & Money": "సంపద & డబ్బు",
        "Health & Body": "ఆరోగ్యం & శరీరం",
        "Purpose & Spirituality": "లక్ష్యం & ఆధ్యాత్మికత",
        "Habits & Productivity": "అలవాట్లు & ఉత్పాదకత",
        "Focus & Deep Work": "ఫోకస్ & లోతైన పని",
        "Leadership & Influence": "నాయకత్వం & ప్రభావం",
        "Career & Business": "కెరీర్ & వ్యాపారం",
        "Relationships & Communication": "సంబంధాలు & కమ్యూనికేషన్",
        "Creativity & Expression": "సృజనాత్మకత & వ్యక్తీకరణ",
        "Nutrition & Wellness": "పోషణ & ఆరోగ్యం",
        "Grief, Loss & Healing": "దుఃఖం, నష్టం & వైద్యం",
        "Success": "విజయం",
        "Motivation": "ప్రేరణ",
        "Spirituality": "ఆధ్యాత్మికత",
        "Mental Wellness": "మానసిక ఆరోగ్యం",
        "Health": "ఆరోగ్యం",
        "Finance": "ఆర్థికం",
        "Productivity": "ఉత్పాదకత",
        "Creativity": "సృజనాత్మకత",
        "Communication": "కమ్యూనికేషన్",
      },
    },
    modal: {
      labels: { summary: "సారాంశం", insights: "ముఖ్య అంతర్దృష్టులు", actionItems: "కార్యాచరణ అంశాలు", coreTheme: "కోర్ థీమ్" },
      translating: "అనువదిస్తున్నాం...",
      translationUnavailable: "అనువాదం అందుబాటులో లేదు. ఆంగ్లం చూపిస్తున్నాం.",
    },
    waitlist: {
      heading: "iCraftz మొదట అనుభవించండి",
      subheading: "జ్ఞానాన్ని చర్యగా మార్చే వేలాది పాఠకులతో చేరండి.",
      placeholder: "మీ ఇమెయిల్ చిరునామా నమోదు చేయండి",
      cta: "వెయిట్‌లిస్ట్‌లో చేరండి",
      success: "మీరు జాబితాలో ఉన్నారు! మేము త్వరలో సంప్రదిస్తాం.",
      error: "ఏదో తప్పు జరిగింది. దయచేసి మళ్ళీ ప్రయత్నించండి.",
    },
    footer: {
      tagline: "పేజీలను అభ్యాసంగా మార్చండి",
      links: { about: "మా గురించి", faq: "తరచుగా అడిగే ప్రశ్నలు", contact: "సంప్రదించండి", product: "ఉత్పత్తి", library: "పుస్తక గ్రంథాలయం", features: "ఫీచర్లు", howItWorks: "ఎలా పని చేస్తుంది", company: "కంపెనీ", resources: "వనరులు", blog: "బ్లాగ్", helpCenter: "సహాయ కేంద్రం", community: "కమ్యూనిటీ", privacy: "గోప్యతా విధానం", terms: "సేవా నిబంధనలు" },
      copyright: "© 2025 iCraftz. అన్ని హక్కులు రిజర్వ్ చేయబడ్డాయి.",
    },
  },

  ta: {
    langLabel: "தமிழ்",
    nav: { home: "முகப்பு", library: "நூலகம்", categories: "வகைகள்", waitlist: "காத்திருப்பு பட்டியலில் சேரவும்" },
    hero: {
      tagline: "வாசிப்பதைத் தாண்டி. உங்களை மாற்றிக்கொள்ளுங்கள்.",
      subtext: "iCraftz வெறும் வாசிப்பை மட்டுமே வழங்கவில்லை. உலகின் தலைசிறந்த நான்-ஃபிக்ஷன் நூல்களின் ஆழ்ந்த ஞானத்தை, உங்கள் வாழ்வை அடியோடு புதுப்பிக்கும் தினசரி பயிற்சியாக மாற்றும் ஒரு பரிணாமப் பயணம் இது.",
      cta: "காத்திருப்பு பட்டியலில் சேரவும்",
      subCta: "iCraftz-ஐ முதலில் அனுபவிப்பவர்களில் ஒருவராகுங்கள்",
    },
    howItWorks: {
      heading: "இது எப்படி செயல்படுகிறது",
      steps: [
        { title: "ஒரு புத்தகம் தேர்வு செய்யுங்கள்", desc: "49 வாழ்க்கையை மாற்றும் நான்-ஃபிக்ஷன் புத்தகங்களின் நூலகத்தை உலாவுங்கள்." },
        { title: "நுண்ணறிவுகளை கண்டறியுங்கள்", desc: "உங்கள் மொழியில் முக்கிய கருத்துக்கள், கருப்பொருள்கள் மற்றும் பாடங்களை ஆராயுங்கள்." },
        { title: "உங்கள் வாழ்வில் பயன்படுத்துங்கள்", desc: "இன்றே தொடங்கக்கூடிய நடைமுறை செயல் திட்டங்களை பெறுங்கள்." },
      ],
    },
    library: { heading: "உங்கள் தனிப்பட்ட நூலகம்", subheading: "AI-இயக்கப்படும் செயல் திட்டங்களுடன் 8 மாற்றும் புத்தகங்கள்", searchPlaceholder: "புத்தகங்களை தேடுங்கள்..." },
    categories: {
      heading: "உங்கள் வாழ்வை மாற்றுங்கள்",
      subheading: "நீங்கள் மேம்படுத்த விரும்பும் வாழ்க்கை துறை மூலம் புத்தகங்களை ஆராயுங்கள்.",
      bookCount: "புத்தகங்கள்",
      comingSoon: "விரைவில் வருகிறது — இந்த பகுதிக்கான சிறந்த புத்தகங்களை தொகுக்கிறோம்!",
      names: {
        "Mind & Mindset": "மனம் & மனநிலை",
        "Wealth & Money": "செல்வம் & பணம்",
        "Health & Body": "உடல் ஆரோக்கியம்",
        "Purpose & Spirituality": "நோக்கம் & ஆன்மீகம்",
        "Habits & Productivity": "பழக்கங்கள் & உற்பத்தித்திறன்",
        "Focus & Deep Work": "கவனம் & ஆழமான வேலை",
        "Leadership & Influence": "தலைமை & செல்வாக்கு",
        "Career & Business": "தொழில் & வணிகம்",
        "Relationships & Communication": "உறவுகள் & தொடர்பு",
        "Creativity & Expression": "படைப்பாற்றல் & வெளிப்பாடு",
        "Nutrition & Wellness": "ஊட்டச்சத்து & நலன்",
        "Grief, Loss & Healing": "துக்கம், இழப்பு & குணமடைதல்",
        "Success": "வெற்றி",
        "Motivation": "உந்துதல்",
        "Spirituality": "ஆன்மீகம்",
        "Mental Wellness": "மன நலம்",
        "Health": "ஆரோக்கியம்",
        "Finance": "நிதி",
        "Productivity": "உற்பத்தித்திறன்",
        "Creativity": "படைப்பாற்றல்",
        "Communication": "தொடர்பு",
      },
    },
    modal: {
      labels: { summary: "சுருக்கம்", insights: "முக்கிய நுண்ணறிவுகள்", actionItems: "செயல் திட்டங்கள்", coreTheme: "மையக் கருப்பொருள்" },
      translating: "மொழிபெயர்க்கிறோம்...",
      translationUnavailable: "மொழிபெயர்ப்பு கிடைக்கவில்லை. ஆங்கிலம் காட்டப்படுகிறது.",
    },
    waitlist: {
      heading: "iCraftz-ஐ முதலில் அனுபவியுங்கள்",
      subheading: "ஞானத்தை செயலாக மாற்றும் ஆயிரக்கணக்கான வாசகர்களுடன் சேருங்கள்.",
      placeholder: "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடவும்",
      cta: "காத்திருப்பு பட்டியலில் சேரவும்",
      success: "நீங்கள் பட்டியலில் இருக்கிறீர்கள்! விரைவில் தொடர்பு கொள்கிறோம்.",
      error: "ஏதோ தவறு நடந்தது. மீண்டும் முயற்சிக்கவும்.",
    },
    footer: {
      tagline: "பக்கங்களை பயிற்சியாக மாற்றுங்கள்",
      links: { about: "எங்களை பற்றி", faq: "அடிக்கடி கேட்கப்படும் கேள்விகள்", contact: "தொடர்பு கொள்ளுங்கள்", product: "தயாரிப்பு", library: "புத்தக நூலகம்", features: "அம்சங்கள்", howItWorks: "எப்படி வேலை செய்கிறது", company: "நிறுவனம்", resources: "வளங்கள்", blog: "வலைப்பதிவு", helpCenter: "உதவி மையம்", community: "சமூகம்", privacy: "தனியுரிமைக் கொள்கை", terms: "சேவை விதிமுறைகள்" },
      copyright: "© 2025 iCraftz. அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    },
  },

  kn: {
    langLabel: "ಕನ್ನಡ",
    nav: { home: "ಮುಖಪುಟ", library: "ಗ್ರಂಥಾಲಯ", categories: "ವರ್ಗಗಳು", waitlist: "ವೇಟ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿ" },
    hero: {
      tagline: "ಓದುವುದಷ್ಟೇ ಅಲ್ಲ. ನಿಮ್ಮ ಜೀವನವನ್ನು ರೂಪಿಸಿಕೊಳ್ಳಿ.",
      subtext: "iCraftz ಎನ್ನುವುದು ಕೇವಲ ಓದುವ ತಾಣವಲ್ಲ. ಜಗತ್ತಿನ ಶ್ರೇಷ್ಠ ನಾನ್-ಫಿಕ್ಷನ್ ಗ್ರಂಥಗಳ ಆಳವಾದ ಜ್ಞಾನವನ್ನು, ನಿಮ್ಮ ಬದುಕನ್ನು ಒಳಗಿನಿಂದ ರೂಪಿಸುವ ದೈನಂದಿನ ಆಚರಣೆಯಾಗಿ ಬದಲಾಯಿಸುವ ಒಂದು ಪರಿವರ್ತನಾ ಪಯಣ.",
      cta: "ವೇಟ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿ",
      subCta: "iCraftz ಅನುಭವಿಸುವ ಮೊದಲಿಗರಲ್ಲಿ ಒಬ್ಬರಾಗಿ",
    },
    howItWorks: {
      heading: "ಇದು ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ",
      steps: [
        { title: "ಪುಸ್ತಕ ಆರಿಸಿ", desc: "49 ಜೀವನ ಬದಲಿಸುವ ನಾನ್-ಫಿಕ್ಷನ್ ಪುಸ್ತಕಗಳ ನಮ್ಮ ಗ್ರಂಥಾಲಯವನ್ನು ನೋಡಿ." },
        { title: "ಒಳನೋಟಗಳನ್ನು ಕಂಡುಹಿಡಿಯಿರಿ", desc: "ನಿಮ್ಮ ಭಾಷೆಯಲ್ಲಿ ಪ್ರಮುಖ ಆಲೋಚನೆಗಳು, ವಿಷಯಗಳು ಮತ್ತು ಪಾಠಗಳನ್ನು ಅನ್ವೇಷಿಸಿ." },
        { title: "ನಿಮ್ಮ ಜೀವನದಲ್ಲಿ ಅನ್ವಯಿಸಿ", desc: "ಇಂದೇ ಪ್ರಾರಂಭಿಸಬಹುದಾದ ಪ್ರಾಯೋಗಿಕ ಕ್ರಿಯಾ ಅಂಶಗಳನ್ನು ಪಡೆಯಿರಿ." },
      ],
    },
    library: { heading: "ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಗ್ರಂಥಾಲಯ", subheading: "AI-ಚಾಲಿತ ಕ್ರಿಯಾ ಯೋಜನೆಗಳೊಂದಿಗೆ 8 ಪರಿವರ್ತನಾ ಪುಸ್ತಕಗಳು", searchPlaceholder: "ಪುಸ್ತಕಗಳನ್ನು ಹುಡುಕಿ..." },
    categories: {
      heading: "ನಿಮ್ಮ ಜೀವನ ಬದಲಿಸಿ",
      subheading: "ನೀವು ಸುಧಾರಿಸಲು ಬಯಸುವ ಜೀವನ ಕ್ಷೇತ್ರದ ಮೂಲಕ ಪುಸ್ತಕಗಳನ್ನು ಅನ್ವೇಷಿಸಿ.",
      bookCount: "ಪುಸ್ತಕಗಳು",
      comingSoon: "ಶೀಘ್ರದಲ್ಲೇ ಬರುತ್ತಿದೆ — ಈ ಕ್ಷೇತ್ರಕ್ಕಾಗಿ ಅತ್ಯುತ್ತಮ ಪುಸ್ತಕಗಳನ್ನು ಸಂಗ್ರಹಿಸುತ್ತಿದ್ದೇವೆ!",
      names: {
        "Mind & Mindset": "ಮನಸ್ಸು ಮತ್ತು ಮನೋಭಾವ",
        "Wealth & Money": "ಸಂಪತ್ತು ಮತ್ತು ಹಣ",
        "Health & Body": "ಆರೋಗ್ಯ ಮತ್ತು ದೇಹ",
        "Purpose & Spirituality": "ಉದ್ದೇಶ ಮತ್ತು ಆಧ್ಯಾತ್ಮ",
        "Habits & Productivity": "ಅಭ್ಯಾಸಗಳು ಮತ್ತು ಉತ್ಪಾದಕತೆ",
        "Focus & Deep Work": "ಗಮನ ಮತ್ತು ಆಳವಾದ ಕೆಲಸ",
        "Leadership & Influence": "ನಾಯಕತ್ವ ಮತ್ತು ಪ್ರಭಾವ",
        "Career & Business": "ವೃತ್ತಿ ಮತ್ತು ವ್ಯಾಪಾರ",
        "Relationships & Communication": "ಸಂಬಂಧಗಳು ಮತ್ತು ಸಂವಹನ",
        "Creativity & Expression": "ಸೃಜನಶೀಲತೆ ಮತ್ತು ಅಭಿವ್ಯಕ್ತಿ",
        "Nutrition & Wellness": "ಪೋಷಣೆ ಮತ್ತು ಸ್ವಾಸ್ಥ್ಯ",
        "Grief, Loss & Healing": "ದುಃಖ, ನಷ್ಟ ಮತ್ತು ಗುಣಮುಖ",
        "Success": "ಯಶಸ್ಸು",
        "Motivation": "ಪ್ರೇರಣೆ",
        "Spirituality": "ಆಧ್ಯಾತ್ಮ",
        "Mental Wellness": "ಮಾನಸಿಕ ಆರೋಗ್ಯ",
        "Health": "ಆರೋಗ್ಯ",
        "Finance": "ಹಣಕಾಸು",
        "Productivity": "ಉತ್ಪಾದಕತೆ",
        "Creativity": "ಸೃಜನಶೀಲತೆ",
        "Communication": "ಸಂವಹನ",
      },
    },
    modal: {
      labels: { summary: "ಸಾರಾಂಶ", insights: "ಪ್ರಮುಖ ಒಳನೋಟಗಳು", actionItems: "ಕ್ರಿಯಾ ಅಂಶಗಳು", coreTheme: "ಮೂಲ ವಿಷಯ" },
      translating: "ಅನುವಾದಿಸುತ್ತಿದ್ದೇವೆ...",
      translationUnavailable: "ಅನುವಾದ ಲಭ್ಯವಿಲ್ಲ. ಇಂಗ್ಲಿಷ್ ತೋರಿಸಲಾಗುತ್ತಿದೆ.",
    },
    waitlist: {
      heading: "iCraftz ಮೊದಲು ಅನುಭವಿಸಿ",
      subheading: "ಜ್ಞಾನವನ್ನು ಕ್ರಿಯೆಯಾಗಿ ಪರಿವರ್ತಿಸುವ ಸಾವಿರಾರು ಓದುಗರೊಂದಿಗೆ ಸೇರಿ.",
      placeholder: "ನಿಮ್ಮ ಇಮೇಲ್ ವಿಳಾಸ ನಮೂದಿಸಿ",
      cta: "ವೇಟ್‌ಲಿಸ್ಟ್‌ಗೆ ಸೇರಿ",
      success: "ನೀವು ಪಟ್ಟಿಯಲ್ಲಿದ್ದೀರಿ! ನಾವು ಶೀಘ್ರದಲ್ಲೇ ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
      error: "ಏನೋ ತಪ್ಪಾಯಿತು. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    },
    footer: {
      tagline: "ಪುಟಗಳನ್ನು ಅಭ್ಯಾಸವಾಗಿ ಪರಿವರ್ತಿಸಿ",
      links: { about: "ನಮ್ಮ ಬಗ್ಗೆ", faq: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು", contact: "ಸಂಪರ್ಕಿಸಿ", product: "ಉತ್ಪನ್ನ", library: "ಪುಸ್ತಕ ಗ್ರಂಥಾಲಯ", features: "ವೈಶಿಷ್ಟ್ಯಗಳು", howItWorks: "ಹೇಗೆ ಕೆಲಸ ಮಾಡುತ್ತದೆ", company: "ಕಂಪನಿ", resources: "ಸಂಪನ್ಮೂಲಗಳು", blog: "ಬ್ಲಾಗ್", helpCenter: "ಸಹಾಯ ಕೇಂದ್ರ", community: "ಸಮುದಾಯ", privacy: "ಗೌಪ್ಯತಾ ನೀತಿ", terms: "ಸೇವಾ ನಿಯಮಗಳು" },
      copyright: "© 2025 iCraftz. ಎಲ್ಲ ಹಕ್ಕುಗಳು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    },
  },

  mr: {
    langLabel: "मराठी",
    nav: { home: "मुख्यपृष्ठ", library: "ग्रंथालय", categories: "श्रेण्या", waitlist: "प्रतीक्षा यादीत सामील व्हा" },
    hero: {
      tagline: "फक्त वाचू नका. स्वतःला घडवा.",
      subtext: "iCraftz हे केवळ वाचनाचे ठिकाण नाही. जगातील श्रेष्ठ नॉन-फिक्शन ग्रंथांमधले गहन शहाणपण, तुमच्या जीवनाला आतून घडवणाऱ्या रोजच्या कृतीत रूपांतरित करणारा हा परिवर्तनाचा प्रवास आहे.",
      cta: "प्रतीक्षा यादीत सामील व्हा",
      subCta: "iCraftz अनुभवणाऱ्यांमध्ये पहिले व्हा",
    },
    howItWorks: {
      heading: "हे कसे कार्य करते",
      steps: [
        { title: "एक पुस्तक निवडा", desc: "49 जीवन बदलणाऱ्या नॉन-फिक्शन पुस्तकांच्या आमच्या संग्रहात पहा." },
        { title: "अंतर्दृष्टी शोधा", desc: "तुमच्या भाषेत मुख्य कल्पना, विषय आणि धडे जाणून घ्या." },
        { title: "तुमच्या जीवनात लागू करा", desc: "तुम्ही आजपासून सुरू करू शकणारे व्यावहारिक कृती मुद्दे मिळवा." },
      ],
    },
    library: { heading: "तुमचे वैयक्तिक ग्रंथालय", subheading: "AI-चालित कृती योजनांसह 8 परिवर्तनकारी पुस्तके", searchPlaceholder: "पुस्तके शोधा..." },
    categories: {
      heading: "तुमचे जीवन बदला",
      subheading: "तुम्हाला सुधारायच्या जीवनाच्या क्षेत्रानुसार पुस्तके शोधा.",
      bookCount: "पुस्तके",
      comingSoon: "लवकरच येत आहे — या क्षेत्रासाठी सर्वोत्तम पुस्तके क्युरेट करत आहोत!",
      names: {
        "Mind & Mindset": "मन व मानसिकता",
        "Wealth & Money": "संपत्ती व पैसा",
        "Health & Body": "आरोग्य व शरीर",
        "Purpose & Spirituality": "उद्देश व आध्यात्मिकता",
        "Habits & Productivity": "सवयी व उत्पादकता",
        "Focus & Deep Work": "लक्ष व सखोल काम",
        "Leadership & Influence": "नेतृत्व व प्रभाव",
        "Career & Business": "करिअर व व्यवसाय",
        "Relationships & Communication": "नातेसंबंध व संवाद",
        "Creativity & Expression": "सर्जनशीलता व अभिव्यक्ती",
        "Nutrition & Wellness": "पोषण व निरोगीपणा",
        "Grief, Loss & Healing": "दुःख, हानी व उपचार",
        "Success": "यश",
        "Motivation": "प्रेरणा",
        "Spirituality": "आध्यात्मिकता",
        "Mental Wellness": "मानसिक आरोग्य",
        "Health": "आरोग्य",
        "Finance": "वित्त",
        "Productivity": "उत्पादकता",
        "Creativity": "सर्जनशीलता",
        "Communication": "संवाद",
      },
    },
    modal: {
      labels: { summary: "सारांश", insights: "मुख्य अंतर्दृष्टी", actionItems: "कृती मुद्दे", coreTheme: "मूळ विषय" },
      translating: "भाषांतर होत आहे...",
      translationUnavailable: "भाषांतर उपलब्ध नाही. इंग्रजी दाखवत आहे.",
    },
    waitlist: {
      heading: "iCraftz प्रथम अनुभवा",
      subheading: "ज्ञानाला कृतीत रूपांतरित करणाऱ्या हजारो वाचकांमध्ये सामील व्हा.",
      placeholder: "तुमचा ईमेल पत्ता प्रविष्ट करा",
      cta: "प्रतीक्षा यादीत सामील व्हा",
      success: "तुम्ही यादीत आहात! आम्ही लवकरच संपर्क करू.",
      error: "काहीतरी चुकले. कृपया पुन्हा प्रयत्न करा.",
    },
    footer: {
      tagline: "पानांना सरावात रूपांतरित करा",
      links: { about: "आमच्याबद्दल", faq: "वारंवार विचारले जाणारे प्रश्न", contact: "संपर्क करा", product: "उत्पादन", library: "पुस्तक ग्रंथालय", features: "वैशिष्ट्ये", howItWorks: "कसे कार्य करते", company: "कंपनी", resources: "संसाधने", blog: "ब्लॉग", helpCenter: "मदत केंद्र", community: "समुदाय", privacy: "गोपनीयता धोरण", terms: "सेवा अटी" },
      copyright: "© 2025 iCraftz. सर्व हक्क राखीव.",
    },
  },

  bn: {
    langLabel: "বাংলা",
    nav: { home: "হোম", library: "লাইব্রেরি", categories: "বিভাগসমূহ", waitlist: "অপেক্ষা তালিকায় যোগ দিন" },
    hero: {
      tagline: "শুধু পড়বেন না। নিজেকে বদলে ফেলুন।",
      subtext: "iCraftz কোনো সাধারণ পাঠের জায়গা নয়। পৃথিবীর শ্রেষ্ঠ নন-ফিকশন গ্রন্থগুলোর গভীর প্রজ্ঞাকে, আপনার জীবনকে ভেতর থেকে গড়ে তোলার মতো প্রতিদিনের অনুশীলনে রূপান্তর করে দেয় এই অভিযাত্রা।",
      cta: "অপেক্ষা তালিকায় যোগ দিন",
      subCta: "iCraftz অনুভব করার প্রথমদের মধ্যে থাকুন",
    },
    howItWorks: {
      heading: "এটি কীভাবে কাজ করে",
      steps: [
        { title: "একটি বই বেছে নিন", desc: "৪৬টি জীবন-পরিবর্তনকারী নন-ফিকশন বইয়ের আমাদের লাইব্রেরি ব্রাউজ করুন।" },
        { title: "অন্তর্দৃষ্টি আবিষ্কার করুন", desc: "আপনার ভাষায় মূল ধারণা, থিম এবং শিক্ষা অন্বেষণ করুন।" },
        { title: "আপনার জীবনে প্রয়োগ করুন", desc: "আজই শুরু করতে পারেন এমন ব্যবহারিক কর্ম আইটেম পান।" },
      ],
    },
    library: { heading: "আপনার ব্যক্তিগত লাইব্রেরি", subheading: "AI-চালিত অ্যাকশন প্ল্যান সহ ৮টি রূপান্তরকারী বই", searchPlaceholder: "বই খুঁজুন..." },
    categories: {
      heading: "আপনার জীবন পরিবর্তন করুন",
      subheading: "আপনি যে জীবনের ক্ষেত্র উন্নত করতে চান তার মাধ্যমে বই অন্বেষণ করুন।",
      bookCount: "বই",
      comingSoon: "শীঘ্রই আসছে — এই ক্ষেত্রের জন্য সেরা বইগুলো কিউরেট করছি!",
      names: {
        "Mind & Mindset": "মন ও মানসিকতা",
        "Wealth & Money": "সম্পদ ও অর্থ",
        "Health & Body": "স্বাস্থ্য ও শরীর",
        "Purpose & Spirituality": "উদ্দেশ্য ও আধ্যাত্মিকতা",
        "Habits & Productivity": "অভ্যাস ও উৎপাদনশীলতা",
        "Focus & Deep Work": "মনোযোগ ও গভীর কাজ",
        "Leadership & Influence": "নেতৃত্ব ও প্রভাব",
        "Career & Business": "ক্যারিয়ার ও ব্যবসা",
        "Relationships & Communication": "সম্পর্ক ও যোগাযোগ",
        "Creativity & Expression": "সৃজনশীলতা ও প্রকাশ",
        "Nutrition & Wellness": "পুষ্টি ও সুস্থতা",
        "Grief, Loss & Healing": "শোক, ক্ষতি ও নিরাময়",
        "Success": "সাফল্য",
        "Motivation": "অনুপ্রেরণা",
        "Spirituality": "আধ্যাত্মিকতা",
        "Mental Wellness": "মানসিক স্বাস্থ্য",
        "Health": "স্বাস্থ্য",
        "Finance": "অর্থ",
        "Productivity": "উৎপাদনশীলতা",
        "Creativity": "সৃজনশীলতা",
        "Communication": "যোগাযোগ",
      },
    },
    modal: {
      labels: { summary: "সারসংক্ষেপ", insights: "মূল অন্তর্দৃষ্টি", actionItems: "কর্ম আইটেম", coreTheme: "মূল থিম" },
      translating: "অনুবাদ হচ্ছে...",
      translationUnavailable: "অনুবাদ পাওয়া যাচ্ছে না। ইংরেজি দেখানো হচ্ছে।",
    },
    waitlist: {
      heading: "iCraftz প্রথমে অনুভব করুন",
      subheading: "জ্ঞানকে কর্মে পরিণত করা হাজার হাজার পাঠকের সাথে যোগ দিন।",
      placeholder: "আপনার ইমেইল ঠিকানা দিন",
      cta: "অপেক্ষা তালিকায় যোগ দিন",
      success: "আপনি তালিকায় আছেন! আমরা শীঘ্রই যোগাযোগ করব।",
      error: "কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন।",
    },
    footer: {
      tagline: "পাতাগুলোকে অভ্যাসে পরিণত করুন",
      links: { about: "আমাদের সম্পর্কে", faq: "সচরাচর জিজ্ঞাসা", contact: "যোগাযোগ করুন", product: "পণ্য", library: "বই লাইব্রেরি", features: "বৈশিষ্ট্য", howItWorks: "কিভাবে কাজ করে", company: "কোম্পানি", resources: "সম্পদ", blog: "ব্লগ", helpCenter: "সহায়তা কেন্দ্র", community: "সম্প্রদায়", privacy: "গোপনীয়তা নীতি", terms: "সেবার শর্তাবলী" },
      copyright: "© ২০২৫ iCraftz. সমস্ত অধিকার সংরক্ষিত।",
    },
  },

  gu: {
    langLabel: "ગુજરાતી",
    nav: { home: "હોમ", library: "લાઇબ્રેરી", categories: "શ્રેણીઓ", waitlist: "વેઇટલિસ્ટમાં જોડાઓ" },
    hero: {
      tagline: "માત્ર વાંચશો નહીં. પોતાને બદલો.",
      subtext: "iCraftz એ માત્ર વાંચન-મંચ નથી. વિશ્વના શ્રેષ્ઠ નૉન-ફિક્શન ગ્રંથોની ઊંડી જ્ઞાનજ્યોતને, તમારા જીવનને ભીતરથી નવી દિશા આપતી રોજિંદી સાધનામાં બદલી નાખતી એક પરિવર્તનયાત્રા છે.",
      cta: "વેઇટલિસ્ટમાં જોડાઓ",
      subCta: "iCraftz અનુભવ કરનારા પ્રથમ લોકોમાં બનો",
    },
    howItWorks: {
      heading: "આ કેવી રીતે કામ કરે છે",
      steps: [
        { title: "એક પુસ્તક પસંદ કરો", desc: "49 જીવન-પરિવર્તક નૉન-ફિક્શન પુસ્તકોની અમારી લાઇબ્રેરી બ્રાઉઝ કરો." },
        { title: "અંતર્દૃષ્ટિ શોધો", desc: "તમારી ભાષામાં મુખ્ય વિચારો, થીમ્સ અને પાઠ શોધો." },
        { title: "તમારા જીવનમાં લાગુ કરો", desc: "વ્યવહારુ કાર્ય આઇટમ્સ મેળવો જે તમે આજે જ શરૂ કરી શકો." },
      ],
    },
    library: { heading: "તમારી વ્યક્તિગત લાઇબ્રેરી", subheading: "AI-સંચાલિત એક્શન પ્લાન સાથે 8 પરિવર્તનકારી પુસ્તકો", searchPlaceholder: "પુસ્તકો શોધો..." },
    categories: {
      heading: "તમારું જીવન બદલો",
      subheading: "તમે જે જીવન ક્ષેત્ર સુધારવા ઇચ્છો છો તે દ્વારા પુસ્તકો શોધો.",
      bookCount: "પુસ્તકો",
      comingSoon: "ટૂંક સમયમાં આવી રહ્યું છે — આ ક્ષેત્ર માટે શ્રેષ્ઠ પુસ્તકો ક્યુરેટ કરી રહ્યા છીએ!",
      names: {
        "Mind & Mindset": "મન અને માનસિકતા",
        "Wealth & Money": "સંપત્તિ અને પૈસા",
        "Health & Body": "આરોગ્ય અને શરીર",
        "Purpose & Spirituality": "હેતુ અને આધ્યાત્મિકતા",
        "Habits & Productivity": "આદતો અને ઉત્પાદકતા",
        "Focus & Deep Work": "ધ્યાન અને ઊંડું કામ",
        "Leadership & Influence": "નેતૃત્વ અને પ્રભાવ",
        "Career & Business": "કારકિર્દી અને વ્યવસાય",
        "Relationships & Communication": "સંબંધો અને સંચાર",
        "Creativity & Expression": "સર્જનાત્મકતા અને અભિવ્યક્તિ",
        "Nutrition & Wellness": "પોષણ અને સ્વાસ્થ્ય",
        "Grief, Loss & Healing": "દુઃખ, નુકસાન અને ઉપચાર",
        "Success": "સફળતા",
        "Motivation": "પ્રેરણા",
        "Spirituality": "આધ્યાત્મિકતા",
        "Mental Wellness": "માનસિક સ્વાસ્થ્ય",
        "Health": "આરોગ્ય",
        "Finance": "નાણાં",
        "Productivity": "ઉત્પાદકતા",
        "Creativity": "સર્જનાત્મકતા",
        "Communication": "સંચાર",
      },
    },
    modal: {
      labels: { summary: "સારાંશ", insights: "મુખ્ય અંતર્દૃષ્ટિ", actionItems: "કાર્ય મુદ્દા", coreTheme: "મૂળ થીમ" },
      translating: "અનુવાદ થઈ રહ્યો છે...",
      translationUnavailable: "અનુવાદ ઉપલબ્ધ નથી. અંગ્રેજી બતાવી રહ્યા છીએ.",
    },
    waitlist: {
      heading: "iCraftz પ્રથમ અનુભવો",
      subheading: "જ્ઞાનને ક્રિયામાં ફેરવતા હજારો વાચકો સાથે જોડાઓ.",
      placeholder: "તમારું ઇમેઇલ સરનામું દાખલ કરો",
      cta: "વેઇટલિસ્ટમાં જોડાઓ",
      success: "તમે યાદીમાં છો! અમે ટૂંક સમયમાં સંપર્ક કરીશું.",
      error: "કઈ ભૂલ થઈ. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
    footer: {
      tagline: "પૃષ્ઠોને અભ્યાસમાં રૂપાંતરિત કરો",
      links: { about: "અમારા વિશે", faq: "વારંવાર પૂછાતા પ્રશ્નો", contact: "સંપર્ક કરો", product: "ઉત્પાદન", library: "પુસ્તક પુસ્તકાલય", features: "સુવિધાઓ", howItWorks: "કેવી રીતે કામ કરે છે", company: "કંપની", resources: "સંસાધનો", blog: "બ્લોગ", helpCenter: "સહાય કેન્દ્ર", community: "સમુદાય", privacy: "ગોપનીયતા નીતિ", terms: "સેવાની શરતો" },
      copyright: "© 2025 iCraftz. સર્વ હક્કો સુરક્ષિત.",
    },
  },

  ml: {
    langLabel: "മലയാളം",
    nav: { home: "ഹോം", library: "ലൈബ്രറി", categories: "വിഭാഗങ്ങൾ", waitlist: "വെയിറ്റ്‌ലിസ്റ്റിൽ ചേരുക" },
    hero: {
      tagline: "വായനയ്ക്ക് അതീതമായി. ജീവിതം മാറ്റിമറിക്കൂ.",
      subtext: "iCraftz വെറുമൊരു വായനാമേടയല്ല. ലോകത്തിലെ ഏറ്റവും ആഴത്തിലുള്ള നോൺ-ഫിക്ഷൻ ഗ്രന്ഥങ്ങളിലെ പ്രജ്ഞയെ, നിങ്ങളുടെ ജീവിതത്തെ ഉള്ളിൽനിന്നു രൂപപ്പെടുത്തുന്ന ദൈനംദിന സാധനയാക്കി മാറ്റുന്ന ഒരു പരിവർത്തന യാത്രയാണ്.",
      cta: "വെയിറ്റ്‌ലിസ്റ്റിൽ ചേരുക",
      subCta: "iCraftz അനുഭവിക്കുന്ന ആദ്യത്തെ ആളുകളിൽ ഒരാളാകുക",
    },
    howItWorks: {
      heading: "ഇത് എങ്ങനെ പ്രവർത്തിക്കുന്നു",
      steps: [
        { title: "ഒരു പുസ്തകം തിരഞ്ഞെടുക്കുക", desc: "ജീവിതം മാറ്റുന്ന 49 നോൺ-ഫിക്ഷൻ പുസ്തകങ്ങളുടെ ഞങ്ങളുടെ ലൈബ്രറി ബ്രൗസ് ചെയ്യുക." },
        { title: "ഉൾക്കാഴ്ചകൾ കണ്ടെത്തുക", desc: "നിങ്ങളുടെ ഭാഷയിൽ പ്രധാന ആശയങ്ങൾ, തീമുകൾ, പാഠങ്ങൾ എന്നിവ പര്യവേക്ഷണം ചെയ്യുക." },
        { title: "ജീവിതത്തിൽ പ്രയോഗിക്കുക", desc: "ഇന്നു തന്നെ ആരംഭിക്കാൻ കഴിയുന്ന പ്രായോഗിക ആക്ഷൻ ഇനങ്ങൾ നേടുക." },
      ],
    },
    library: { heading: "നിങ്ങളുടെ വ്യക്തിഗത ലൈബ്രറി", subheading: "AI-പവർഡ് ആക്ഷൻ പ്ലാനുകളോടെ 8 പരിവർത്തന പുസ്തകങ്ങൾ", searchPlaceholder: "പുസ്തകങ്ങൾ തിരയുക..." },
    categories: {
      heading: "നിങ്ങളുടെ ജീവിതം മാറ്റുക",
      subheading: "നിങ്ങൾ മെച്ചപ്പെടുത്താൻ ആഗ്രഹിക്കുന്ന ജീവിത മേഖല പ്രകാരം പുസ്തകങ്ങൾ പര്യവേക്ഷണം ചെയ്യുക.",
      bookCount: "പുസ്തകങ്ങൾ",
      comingSoon: "ഉടൻ വരുന്നു — ഈ മേഖലക്ക് ഏറ്റവും മികച്ച പുസ്തകങ്ങൾ ക്യൂറേറ്റ് ചെയ്യുന്നു!",
      names: {
        "Mind & Mindset": "മനസ്സ് & മനോഭാവം",
        "Wealth & Money": "സമ്പത്ത് & പണം",
        "Health & Body": "ആരോഗ്യം & ശരീരം",
        "Purpose & Spirituality": "ലക്ഷ്യം & ആദ്ധ്യാത്മികത",
        "Habits & Productivity": "ശീലങ്ങൾ & ഉൽപ്പാദനക്ഷമത",
        "Focus & Deep Work": "ശ്രദ്ധ & ആഴത്തിലുള്ള ജോലി",
        "Leadership & Influence": "നേതൃത്വം & സ്വാധീനം",
        "Career & Business": "കരിയർ & ബിസിനസ്",
        "Relationships & Communication": "ബന്ധങ്ങൾ & ആശയവിനിമയം",
        "Creativity & Expression": "സൃഷ്ടിപരത & ആവിഷ്കാരം",
        "Nutrition & Wellness": "പോഷണം & ആരോഗ്യം",
        "Grief, Loss & Healing": "ദുഃഖം, നഷ്ടം & സൗഖ്യം",
        "Success": "വിജയം",
        "Motivation": "പ്രചോദനം",
        "Spirituality": "ആദ്ധ്യാത്മികത",
        "Mental Wellness": "മാനസിക ആരോഗ്യം",
        "Health": "ആരോഗ്യം",
        "Finance": "ധനകാര്യം",
        "Productivity": "ഉൽപ്പാദനക്ഷമത",
        "Creativity": "സൃഷ്ടിപരത",
        "Communication": "ആശയവിനിമയം",
      },
    },
    modal: {
      labels: { summary: "സംഗ്രഹം", insights: "പ്രധാന ഉൾക്കാഴ്ചകൾ", actionItems: "ആക്ഷൻ ഇനങ്ങൾ", coreTheme: "കോർ തീം" },
      translating: "വിവർത്തനം ചെയ്യുന്നു...",
      translationUnavailable: "വിവർത്തനം ലഭ്യമല്ല. ഇംഗ്ലീഷ് കാണിക്കുന്നു.",
    },
    waitlist: {
      heading: "iCraftz ആദ്യം അനുഭവിക്കുക",
      subheading: "ജ്ഞാനം പ്രവർത്തനത്തിലേക്ക് മാറ്റുന്ന ആയിരക്കണക്കിന് വായനക്കാരോടൊപ്പം ചേരുക.",
      placeholder: "നിങ്ങളുടെ ഇമെയിൽ വിലാസം നൽകുക",
      cta: "വെയിറ്റ്‌ലിസ്റ്റിൽ ചേരുക",
      success: "നിങ്ങൾ ലിസ്റ്റിലുണ്ട്! ഞങ്ങൾ ഉടൻ ബന്ധപ്പെടും.",
      error: "എന്തോ തെറ്റ് സംഭവിച്ചു. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
    },
    footer: {
      tagline: "പേജുകളെ പ്രാക്ടീസ് ആക്കുക",
      links: { about: "ഞങ്ങളെ കുറിച്ച്", faq: "പതിവായി ചോദിക്കുന്ന ചോദ്യങ്ങൾ", contact: "ബന്ധപ്പെടുക", product: "ഉൽപ്പന്നം", library: "പുസ്തക ലൈബ്രറി", features: "ഫീച്ചറുകൾ", howItWorks: "എങ്ങനെ പ്രവർത്തിക്കുന്നു", company: "കമ്പനി", resources: "റിസോഴ്സസ്", blog: "ബ്ലോഗ്", helpCenter: "സഹായ കേന്ദ്രം", community: "കമ്മ്യൂണിറ്റി", privacy: "സ്വകാര്യതാ നയം", terms: "സേവന നിബന്ധനകൾ" },
      copyright: "© 2025 iCraftz. എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.",
    },
  },

  pa: {
    langLabel: "ਪੰਜਾਬੀ",
    nav: { home: "ਹੋਮ", library: "ਲਾਇਬ੍ਰੇਰੀ", categories: "ਸ਼੍ਰੇਣੀਆਂ", waitlist: "ਉਡੀਕ ਸੂਚੀ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ" },
    hero: {
      tagline: "ਸਿਰਫ਼ ਪੜ੍ਹੋ ਨਾ। ਆਪਣੇ ਆਪ ਨੂੰ ਬਦਲੋ।",
      subtext: "iCraftz ਸਿਰਫ਼ ਪੜ੍ਹਨ ਦੀ ਥਾਂ ਨਹੀਂ। ਦੁਨੀਆ ਦੀਆਂ ਡੂੰਘੀਆਂ ਨਾਨ-ਫਿਕਸ਼ਨ ਕਿਤਾਬਾਂ ਦੀ ਸਿਆਣਪ ਨੂੰ, ਤੁਹਾਡੀ ਜ਼ਿੰਦਗੀ ਨੂੰ ਅੰਦਰੋਂ ਘੜਨ ਵਾਲੀ ਰੋਜ਼ਾਨਾ ਸਾਧਨਾ ਵਿੱਚ ਬਦਲ ਦੇਣ ਵਾਲਾ ਇੱਕ ਪਰਿਵਰਤਨ ਸਫ਼ਰ ਹੈ ਇਹ।",
      cta: "ਉਡੀਕ ਸੂਚੀ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ",
      subCta: "iCraftz ਅਨੁਭਵ ਕਰਨ ਵਾਲਿਆਂ ਵਿੱਚੋਂ ਪਹਿਲੇ ਬਣੋ",
    },
    howItWorks: {
      heading: "ਇਹ ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ",
      steps: [
        { title: "ਇੱਕ ਕਿਤਾਬ ਚੁਣੋ", desc: "49 ਜ਼ਿੰਦਗੀ ਬਦਲਣ ਵਾਲੀਆਂ ਨਾਨ-ਫਿਕਸ਼ਨ ਕਿਤਾਬਾਂ ਦੀ ਸਾਡੀ ਲਾਇਬ੍ਰੇਰੀ ਦੇਖੋ।" },
        { title: "ਸੂਝਾਂ ਲੱਭੋ", desc: "ਆਪਣੀ ਭਾਸ਼ਾ ਵਿੱਚ ਮੁੱਖ ਵਿਚਾਰ, ਵਿਸ਼ੇ ਅਤੇ ਸਬਕ ਖੋਜੋ।" },
        { title: "ਆਪਣੀ ਜ਼ਿੰਦਗੀ ਵਿੱਚ ਲਾਗੂ ਕਰੋ", desc: "ਵਿਹਾਰਕ ਕੰਮ ਦੇ ਨੁਕਤੇ ਪਾਓ ਜੋ ਤੁਸੀਂ ਅੱਜ ਤੋਂ ਸ਼ੁਰੂ ਕਰ ਸਕਦੇ ਹੋ।" },
      ],
    },
    library: { heading: "ਤੁਹਾਡੀ ਨਿੱਜੀ ਲਾਇਬ੍ਰੇਰੀ", subheading: "AI-ਸੰਚਾਲਿਤ ਐਕਸ਼ਨ ਪਲਾਨ ਨਾਲ 8 ਪਰਿਵਰਤਨਕਾਰੀ ਕਿਤਾਬਾਂ", searchPlaceholder: "ਕਿਤਾਬਾਂ ਖੋਜੋ..." },
    categories: {
      heading: "ਆਪਣੀ ਜ਼ਿੰਦਗੀ ਬਦਲੋ",
      subheading: "ਜ਼ਿੰਦਗੀ ਦੇ ਉਸ ਖੇਤਰ ਦੇ ਹਿਸਾਬ ਨਾਲ ਕਿਤਾਬਾਂ ਲੱਭੋ ਜੋ ਤੁਸੀਂ ਸੁਧਾਰਨਾ ਚਾਹੁੰਦੇ ਹੋ।",
      bookCount: "ਕਿਤਾਬਾਂ",
      comingSoon: "ਜਲਦ ਆ ਰਿਹਾ ਹੈ — ਇਸ ਖੇਤਰ ਲਈ ਸਭ ਤੋਂ ਵਧੀਆ ਕਿਤਾਬਾਂ ਕਿਊਰੇਟ ਕਰ ਰਹੇ ਹਾਂ!",
      names: {
        "Mind & Mindset": "ਮਨ ਅਤੇ ਮਾਨਸਿਕਤਾ",
        "Wealth & Money": "ਦੌਲਤ ਅਤੇ ਪੈਸਾ",
        "Health & Body": "ਸਿਹਤ ਅਤੇ ਸਰੀਰ",
        "Purpose & Spirituality": "ਮਕਸਦ ਅਤੇ ਅਧਿਆਤਮਿਕਤਾ",
        "Habits & Productivity": "ਆਦਤਾਂ ਅਤੇ ਉਤਪਾਦਕਤਾ",
        "Focus & Deep Work": "ਧਿਆਨ ਅਤੇ ਡੂੰਘਾ ਕੰਮ",
        "Leadership & Influence": "ਅਗਵਾਈ ਅਤੇ ਪ੍ਰਭਾਵ",
        "Career & Business": "ਕਰੀਅਰ ਅਤੇ ਕਾਰੋਬਾਰ",
        "Relationships & Communication": "ਰਿਸ਼ਤੇ ਅਤੇ ਸੰਚਾਰ",
        "Creativity & Expression": "ਰਚਨਾਤਮਕਤਾ ਅਤੇ ਪ੍ਰਗਟਾਵਾ",
        "Nutrition & Wellness": "ਪੋਸ਼ਣ ਅਤੇ ਤੰਦਰੁਸਤੀ",
        "Grief, Loss & Healing": "ਦੁੱਖ, ਨੁਕਸਾਨ ਅਤੇ ਚੰਗਾ ਹੋਣਾ",
        "Success": "ਸਫਲਤਾ",
        "Motivation": "ਪ੍ਰੇਰਣਾ",
        "Spirituality": "ਅਧਿਆਤਮਿਕਤਾ",
        "Mental Wellness": "ਮਾਨਸਿਕ ਤੰਦਰੁਸਤੀ",
        "Health": "ਸਿਹਤ",
        "Finance": "ਵਿੱਤ",
        "Productivity": "ਉਤਪਾਦਕਤਾ",
        "Creativity": "ਰਚਨਾਤਮਕਤਾ",
        "Communication": "ਸੰਚਾਰ",
      },
    },
    modal: {
      labels: { summary: "ਸਾਰਾਂਸ਼", insights: "ਮੁੱਖ ਸੂਝਾਂ", actionItems: "ਕੰਮ ਦੇ ਨੁਕਤੇ", coreTheme: "ਮੂਲ ਵਿਸ਼ਾ" },
      translating: "ਅਨੁਵਾਦ ਹੋ ਰਿਹਾ ਹੈ...",
      translationUnavailable: "ਅਨੁਵਾਦ ਉਪਲਬਧ ਨਹੀਂ। ਅੰਗਰੇਜ਼ੀ ਦਿਖਾ ਰਹੇ ਹਾਂ।",
    },
    waitlist: {
      heading: "iCraftz ਪਹਿਲਾਂ ਅਨੁਭਵ ਕਰੋ",
      subheading: "ਗਿਆਨ ਨੂੰ ਕਾਰਵਾਈ ਵਿੱਚ ਬਦਲਣ ਵਾਲੇ ਹਜ਼ਾਰਾਂ ਪਾਠਕਾਂ ਨਾਲ ਜੁੜੋ।",
      placeholder: "ਆਪਣਾ ਈਮੇਲ ਪਤਾ ਦਾਖਲ ਕਰੋ",
      cta: "ਉਡੀਕ ਸੂਚੀ ਵਿੱਚ ਸ਼ਾਮਲ ਹੋਵੋ",
      success: "ਤੁਸੀਂ ਸੂਚੀ ਵਿੱਚ ਹੋ! ਅਸੀਂ ਜਲਦ ਸੰਪਰਕ ਕਰਾਂਗੇ।",
      error: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    },
    footer: {
      tagline: "ਪੰਨਿਆਂ ਨੂੰ ਅਭਿਆਸ ਵਿੱਚ ਬਦਲੋ",
      links: { about: "ਸਾਡੇ ਬਾਰੇ", faq: "ਅਕਸਰ ਪੁੱਛੇ ਜਾਂਦੇ ਸਵਾਲ", contact: "ਸੰਪਰਕ ਕਰੋ", product: "ਉਤਪਾਦ", library: "ਕਿਤਾਬ ਲਾਇਬ੍ਰੇਰੀ", features: "ਵਿਸ਼ੇਸ਼ਤਾਵਾਂ", howItWorks: "ਕਿਵੇਂ ਕੰਮ ਕਰਦਾ ਹੈ", company: "ਕੰਪਨੀ", resources: "ਸਰੋਤ", blog: "ਬਲੌਗ", helpCenter: "ਮਦਦ ਕੇਂਦਰ", community: "ਭਾਈਚਾਰਾ", privacy: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ", terms: "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ" },
      copyright: "© 2025 iCraftz. ਸਾਰੇ ਅਧਿਕਾਰ ਸੁਰੱਖਿਅਤ।",
    },
  },

};

export default translations;
